import React from 'react';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import CartSelector from 'views/cart/cart.selector';
import { goToMintPackDetails, isBtoCFlow } from '__utils/common-utils';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { addRankSuffix } from '__utils/common-utils';

const CartSummary: React.FC = () => {
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const getMFDetailsURL = (MFDetail: any) => {
        return (
            "mutual-fund-detail/" +
            MFDetail.brand +
            "/" +
            MFDetail.category +
            "/" +
            MFDetail.subCategory +
            "/" +
            MFDetail.schemeName
        );
    };
    const goToMFDetails = (MFDetail: any) => {
        Mixpanel.track(getEventName("viewMutualFundDetail", "clicked", "mutualFundDetail"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
            mutualFundName: MFDetail.fundName,
            mutualFundSchemeId: MFDetail.schemeId
        });
        let mf_url = getMFDetailsURL(MFDetail);
        window.location.href = getAgentCode() ? window.location.origin + `/${mf_url}?schemeId=${MFDetail.encryptedSchemeId}&agentCode=${getAgentCode()}` : window.location.origin + `/${mf_url}?schemeId=${MFDetail.encryptedSchemeId}`;
    }

    return (
        <div>
            {(cartDetails && cartDetails?.noOfItems > 0) &&
                <section className="cartRightSection">
                    <div className="cartConHead">CART SUMMARY</div>
                    <div className="cartTable">
                        <table cellPadding={1}>
                            <thead>
                                <tr>
                                    <th /><th /><th /><th /> <th /><th /><th />
                                </tr>
                            </thead>
                            <tbody>
                                {(cartDetails !== null && cartDetails.activeMintPackInvestmentDetailList && cartDetails.activeMintPackInvestmentDetailList?.length > 0) && cartDetails.activeMintPackInvestmentDetailList.map((element: any, index: any) => (
                                    <tr key={index}>
                                        <td className="rowSno">
                                            <span>{index + 1}</span>.
                                        </td>
                                        <td colSpan={5} >
                                            <h3>
                                                <a onClick={() => goToMintPackDetails(element)}> {element.packName}</a>
                                            </h3>
                                            <p>
                                                <span>{element.investmentType === "SIP" ? "SIP " : "Lumpsum "}
                                                    investment of  &#8377;{element?.totalAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                                                </span>
                                                <br />
                                                {element.investmentType === "SIP" && <span>on {addRankSuffix(element.investmentDetail[0].sipDate)} of every month for {element.investmentDetail[0].numOfInstallments} month(s)<sup></sup></span>}

                                            </p>
                                        </td>
                                    </tr>))
                                }
                                {(cartDetails !== null && cartDetails.activeCustomizedInvestmentDetailList && cartDetails.activeCustomizedInvestmentDetailList?.length > 0) && cartDetails.activeCustomizedInvestmentDetailList.map((element: any, index: any) => (
                                    <tr key={index}>
                                        <td className="rowSno">
                                            <span>{index + 1 + (cartDetails.activeMintPackInvestmentDetailList ? cartDetails.activeMintPackInvestmentDetailList?.length : 0)}</span>.
                                        </td>
                                        <td colSpan={5} >
                                            <h3>
                                                <a onClick={() => goToMFDetails(element.investmentDetail[0].mutualFund)}> {element.investmentDetail[0].mutualFund.fundName}</a>
                                            </h3>
                                            <p>
                                                <span>{element.investmentType === "SIP" ? "SIP " : "Lumpsum "}
                                                    investment of  &#8377;{element?.totalAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                                                </span>
                                                <br />
                                                {element.investmentType === "SIP" && <span>on {addRankSuffix(element.investmentDetail[0].sipDate)} of every month for {element.investmentDetail[0].numOfInstallments} month(s)<sup></sup></span>}

                                            </p>
                                        </td>
                                    </tr>))
                                }
                            </tbody>
                        </table>
                        <div className="totalInvs">
                            <p>Total Investment <strong><span>&#8377;  {cartDetails?.amount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })} </span></strong>
                            </p>
                        </div>
                    </div>
                </section>
            }
        </div>
    )
}
export default CartSummary;
